import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import WarningIcon from "@mui/icons-material/Warning";
import CustomSubCardData from "./CustomSubCardData";

import GridContainer from "components/CustomGrid/GridContainer.js";
import GridItem from "components/CustomGrid/GridItem.js";
import { getProfilePicture } from "../../services/ConfigServices";

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: 14px;
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;

const Container = styled.div`
  border: 0;
  display: flex;

  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0px;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  position: relative;
  min-width: 0;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`

  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;

const CardSubTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
  font-style: italic;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;

const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  flex-wrap: wrap;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const Separator = styled.div`
border-bottom: 2px solid #a8a8a8;
height: 2px;
margin-bottom: 0.6rem;
margin-left: 0.8rem;
margin-right: 0.8rem;
`;

const NoPhoto = styled.div`
background-color: #9798a0;
    height: 150px;
    padding-top: 60px;
    text-align: center;
`;

const infoWindowImg = {
  height: 'auto',
  maxWidth: '98%',
  marginLeft: '1%',
  verticalAlign: 'middle',
  marginBottom: '10px'
}

const markerInfoCardBody = {
  paddingRight: '1rem',
  paddingLeft: '1rem',
  paddingBottom: '1rem',
}

const pStyle = {
  fontSize: ' 0.875rem',
  lineHeight: ' 1.5',
  marginBottom: '1.25rem',
  fontWeight: '400'
}

const infoWindowCarousel = {
  height: 'auto',
  maxWidth: '100%',
  verticalAlign: 'middle',
  marginTop: "-1rem",
  padding: "1rem",
  backgroundColor: '#605F70',
  color: '#ffffff',
  fontSize: '16px',
  fontWeight: 600
}

const iconStyle = { color: "#297373", fontSize: 50, marginTop: "-0.2rem" };

const getType = (type, subtype) => {
  let typeStr = "";
  if (type == 0) {
    if (subtype == 0)
      typeStr = "Commune";
    else if (subtype == 1)
      typeStr = "EPCI";
    else if (subtype == 1)
      typeStr = "Groupe";
  }
  else if (type == 1)
    typeStr = "Site";
  else if (type == 2) {
    if (subtype == 0)
      typeStr = "Bâtiment";
    else if (subtype == 1)
      typeStr = "Equipement urbain";
  }
  else if (type == 3)
    typeStr = "Zone";
  else if (type == 4)
    typeStr = "Compte client";
  return typeStr;
};

function CustomCardEntiteInfo(props) {

  return (
    <div>
      {props.locationInfo ?
        (
          <Card>
            <TitleContainer>
              <CardTitle>{props.locationInfo?.name}</CardTitle>
              <CardSubTitle>{getType(props.locationInfo?.type, props.locationInfo?.subtype)}</CardSubTitle>
            </TitleContainer>
            <Container>

              <div className={"info-window-img"}>
                {props.locationInfo?.picture ? (
                  <img
                    data-src="holder.js/100px180/"
                    style={infoWindowImg}
                    src={getProfilePicture(props.locationInfo?.picture)}
                    data-holder-rendered="true"
                    alt={""}
                  />
                ) :
                  (<NoPhoto>
                    Aucune photo enregistrée
                  </NoPhoto>
                  )

                }

              </div>
              <DataList>
                <DataContainer>
                  <Data>{"Adresse :"}</Data>
                  <DataResult>{props.locationInfo?.address}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Téléphone :"}</Data>
                  <DataResult>{props.locationInfo?.phone}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Email :"}</Data>
                  <DataResult>{props.locationInfo?.email}</DataResult>
                </DataContainer>
              </DataList>
              <Separator />
              <DataList>
                <DataContainer>
                  <Data>{"Nombre de sites :"}</Data>
                  <DataResult>{props.siteCount ? props.siteCount['1_0'] : '0'}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Nombre de bâtiments :"}</Data>
                  <DataResult>{props.siteCount ? props.siteCount['2_0'] : '0'}</DataResult>
                  {/* <DataResult>{props.siteCount? props.siteCount['1_0']*4 : 4654}</DataResult> */}
                </DataContainer>
                <DataContainer>
                  <Data>{"Nombre d'équipements urbains :"}</Data>
                  <DataResult>{props.siteCount ? props.siteCount['2_1'] : '0'}</DataResult>
                </DataContainer>
                {props.locationInfo?.type === 4 ? <></> :
                  <DataContainer>
                    <Data>{"Surface totale :"}</Data>
                    <DataResult>{props.locationInfo?.brutsurface ? props.locationInfo?.brutsurface + " m²" : ""}</DataResult>
                    {/* <DataResult>{props.siteCount? props.locationInfo?.type === 1 ? 10546 : props.siteCount['1_0']*254 : 4654} m²</DataResult> */}
                  </DataContainer>
                }
              </DataList>
              <Separator />
              {/* <DataList>
                <DataContainer>
                  <Data>{"Impact carbone :"}</Data>
                  <DataResult>{props.locationinfo?.[process.env.REACT_APP_HOME_SERIE_CARBON_1Y] ? props.locationinfo?.[process.env.REACT_APP_HOME_SERIE_CARBON_1Y] + " tCO2/an" : ""}</DataResult>
                </DataContainer>
              </DataList>
              <Separator /> */}
              <DataList>
                <DataContainer>
                  <Data>{"Compteurs d'électricité :"}</Data>
                  <DataResult>{props.locationInfo?.elecmeters ? props.locationInfo?.elecmetersactif + " actif(s) / " + props.locationInfo?.elecmeters : "0"}</DataResult>
                  {/* <DataResult>{props.siteCount? props.siteCount['1_0']*4 : 3554}</DataResult> */}
                </DataContainer>
                <DataContainer>
                  <Data>{"Compteurs de gaz :"}</Data>
                  <DataResult>{props.locationInfo?.gasmeters ? props.locationInfo?.gasmetersactif + " actif(s) / " + props.locationInfo?.gasmeters : "0"}</DataResult>
                  {/* <DataResult>{props.siteCount? props.siteCount['1_0']*2 : 3554}</DataResult> */}
                </DataContainer>
                <DataContainer>
                  <Data>{"Compteurs d'eau :"}</Data>
                  <DataResult>{props.locationInfo?.watermeters ? props.locationInfo?.watermetersactif + " actif(s) / " + props.locationInfo?.watermeters : "0"}</DataResult>
                  {/* <DataResult>{props.siteCount? props.siteCount['1_0']*1 : 3554}</DataResult> */}
                </DataContainer>
                <DataContainer>
                  <Data>{"Compteurs autres fluides :"}</Data>
                  <DataResult>{props.locationInfo?.othermeters ? props.locationInfo?.othermetersactif + " actif(s) / " + props.locationInfo?.othermeters : "0"}</DataResult>
                  {/* <DataResult>{props.siteCount? props.siteCount['1_0']*3 : 3554}</DataResult> */}
                </DataContainer>
              </DataList>
            </Container>
          </Card>
        ) : (<div></div>)}
    </div>
  );
}

CustomCardEntiteInfo.propTypes = {
  locationInfo: PropTypes.object,
  siteCount: PropTypes.object
};

export default CustomCardEntiteInfo;
